import { createSlice } from '@reduxjs/toolkit'

import { storeActions } from '@/store/actions'
import { checkAuth } from '@/store/auth/thunks'

interface State {
  isWaitingForAuthentication: boolean
  isAuthenticated: boolean
}

const initialState: State = {
  isWaitingForAuthentication: true,
  isAuthenticated: false,
}

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(checkAuth.pending, (state) => {
        if (state.isAuthenticated) return // No need to display loading if already authenticated
        state.isWaitingForAuthentication = true
      })
      .addCase(checkAuth.fulfilled, (state) => {
        state.isWaitingForAuthentication = false
        state.isAuthenticated = true
      })
      .addCase(checkAuth.rejected, (state) => {
        state.isWaitingForAuthentication = false
        state.isAuthenticated = false
      })

    builder
      .addCase(storeActions.login.pending, (state) => {
        state.isWaitingForAuthentication = true
      })
      .addCase(storeActions.login.fulfilled, (state) => {
        state.isWaitingForAuthentication = false
        state.isAuthenticated = true
      })
      .addCase(storeActions.login.rejected, (state) => {
        state.isWaitingForAuthentication = false
        state.isAuthenticated = false
      })

    builder.addCase(storeActions.logout.pending, (state) => {
      state.isWaitingForAuthentication = false
      state.isAuthenticated = false
    })
  },
})

// export const { } = slice.actions
export type { State as AuthState }
export const authInitialState = initialState
export default slice.reducer
